export enum ServerStateKeysEnum {
  doctorProfile = 'doctorProfile',
  contentfulData = 'contentfulData',
  productDetails = 'productDetails',
  similarProducts = 'similarProducts',
  orderHistory = 'orderHistory',
  orderDetails = 'orderDetails',
  taxonSlug = 'taxonSlug',
  taxonDetails = 'taxonDetails',
  taxonFilters = 'taxonFilters',
  promotedTaxons = 'promotedTaxons',
  searchProducts = 'searchProducts',
  userCurrentCart = 'userCurrentCart',
  favouriteProductIds = 'favouriteProductIds',
  favouriteProducts = 'favouriteProducts',
  doctorAddresses = 'doctorAddresses',
  orderShipments = 'orderShipments',
  doctorCreditCards = 'doctorCreditCards',
  menus = 'menus',
  productNameList = 'productNameList',
  clamshellTemplates = 'clamshellTemplates',
  couponCodes = 'couponCodes',
  accountDetails = 'accountDetails',
  promotionList = 'promotionList',
  designHuddleToken = 'designHuddleToken',
  designHuddleProjects = 'designHuddleProjects',
  marketingProjects = 'marketingProjects',
  downloadsHistory = 'downloadsHistory',
  scannerDetails = 'scannerDetails',
  userIteroCart = 'userIteroCart',
  approvedIteroProposalDetails = 'approvedIteroProposalDetails',
  iteroorderHistory = 'iteroorderHistory',
  iteroPaymentMethod = 'iteroPaymentMethod',
  subscriptionHistory = 'subscriptionHistory',
  updateSubscription = 'updateSubscription',
  iteroTax = 'iteroTax',
  productsCache = 'productsCache',
  addLineitemMutation = 'addLineitemMutation',
  subscriptionDetail = 'subscriptionDetail',
  subscriptionProductList = 'subscriptionProductList',
  isIDSStoreDisabled = 'isIDSStoreDisabled',
  auth0UserInfo = 'auth0UserInfo',
  dsoProducts = 'dsoProducts',
  dsoProductDetails = 'dsoProductDetails',
  dsoCart = 'dsoCart',
  dsoOrderHistory = 'dsoOrderHistory',
  dsoOrderHistoryFilters = 'dsoOrderHistoryFilters',
  dsoOrderDetails = 'dsoOrderDetails',
  dsoShippingAddresses = 'dsoShippingAddresses',
  dsoBillingAddresses = 'dsoBillingAddresses',
  dsoBillingAddressesByShipAccount = 'dsoBillingAddressesByShipAccount',
  dsoAddLineitemMutation = 'dsoAddLineitemMutation',
  dsoUpdateLineitemMutation = 'dsoUpdateLineitemMutation',
  dsoRemoveLineitemMutation = 'dsoRemoveLineitemMutation',
  dsoCartSummary = 'dsoCartSummary',
  dsoSaveOrderAddressMutation = 'dsoSaveOrderAddressMutation',
  dsoShippingMethods = 'dsoShippingMethods',
  dsoPaymentMethods = 'dsoPaymentMethods',
  dsoTaxons = 'dsoTaxons',
  dsoDiscounts = 'dsoDiscounts',
  dsoProductSearch = 'dsoProductSearch',
  dsoFavouriteProductIds = 'dsoFavouriteProductIds',
  dsoIdsStoreSettings = 'dsoIdsStoreSettings',
  dsoSaveIdsStoreSettings = 'dsoSaveIdsStoreSettings',
  dsoPermissions = 'dsoPermissions',
}
